import { injectable } from 'inversify';

@injectable()
// Class to store current call state parameters
// Only for simple/plain values: string, number, etc...
export class CallState {
  appId?: string;

  isJoined = false;

  channelId?: string;

  isChannelJoining = false;

  reset(): void {
    this.appId = undefined;
    this.channelId = undefined;
    this.isJoined = false;
    this.isChannelJoining = false;
  }
}
